import React, { useEffect, useState } from 'react';
import { isAuthValid, getSessionTimeRemaining, clearAuthData, extendSession, setShortSessionExpiry } from '../utils/authUtils';

const SessionMonitor = ({ onLogout }) => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    // Check session status every 30 seconds
    const checkSession = () => {
      if (!isAuthValid()) {
        // Session expired, logout
        clearAuthData();
        if (onLogout) {
          onLogout();
        }
        return;
      }

      const remaining = getSessionTimeRemaining();
      setTimeRemaining(remaining);

      // Show warning when less than 5 minutes remaining (300 seconds)
      if (remaining <= 300 && remaining > 0) {
        setShowWarning(true);
      } else {
        setShowWarning(false);
      }
    };

    // Check immediately
    checkSession();

    // Set up interval to check every 30 seconds
    const interval = setInterval(checkSession, 30000);

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, [onLogout]);

  // Handle session extension
  const handleExtendSession = () => {
    extendSession();
    setShowWarning(false);
  };

  // Handle short session expiry
  const handleShortExpiry = () => {
    setShortSessionExpiry();
    setShowWarning(false);
  };

  // Format time remaining for display
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  if (!showWarning) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 bg-yellow-50 border border-yellow-200 rounded-lg p-4 shadow-lg z-50 max-w-sm">
      <div className="flex items-center">
        <svg className="w-5 h-5 text-yellow-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        <div className="flex-1">
          <h3 className="text-sm font-medium text-yellow-800">
            Sessiya bitir
          </h3>
          <p className="text-sm text-yellow-700 mt-1">
            Sessiya {formatTime(timeRemaining)} sonra bitəcək
          </p>
        </div>
      </div>
      <div className="mt-3 flex space-x-2">
        <button
          onClick={handleExtendSession}
          className="bg-yellow-600 text-white px-3 py-1 rounded text-sm hover:bg-yellow-700 transition-colors"
        >
          Uzat
        </button>
        <button
          onClick={handleShortExpiry}
          className="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700 transition-colors"
        >
          Tez bitir
        </button>
        <button
          onClick={() => setShowWarning(false)}
          className="bg-gray-300 text-gray-700 px-3 py-1 rounded text-sm hover:bg-gray-400 transition-colors"
        >
          Bağla
        </button>
      </div>
    </div>
  );
};

export default SessionMonitor; 